import { useEffect, useState } from 'react'
import { getMyGrants } from '../utils/fileBrowserApi'
import { useUserContext } from '../context/UserContext'

// Session-level cache: grants change rarely and several components (sidebars,
// dashboard, file browser) ask for them on the same render pass. Keyed by user
// id so a sign-out/sign-in in the same tab doesn't serve another user's grants.
let cachedUserId = null
let cachedPromise = null

const fetchMyGrantsOnce = userId => {
  if (!cachedPromise || cachedUserId !== userId) {
    cachedUserId = userId
    cachedPromise = getMyGrants().catch(error => {
      cachedPromise = null
      throw error
    })
  }
  return cachedPromise
}

export default function useMyFileGrants() {
  const { userData, isSaddlefitAdmin } = useUserContext()
  const [prefixes, setPrefixes] = useState([])
  const [accessByPrefix, setAccessByPrefix] = useState({})
  const [loading, setLoading] = useState(false)

  const enabled = Boolean(userData) && !isSaddlefitAdmin

  useEffect(() => {
    if (!enabled) return
    let active = true
    setLoading(true)
    fetchMyGrantsOnce(userData.id)
      .then(res => {
        if (!active) return
        setPrefixes(res?.prefixes || [])
        setAccessByPrefix(res?.accessByPrefix || {})
      })
      .catch(() => {
        if (!active) return
        setPrefixes([])
        setAccessByPrefix({})
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [enabled, userData?.id])

  return { prefixes, accessByPrefix, hasGrants: prefixes.length > 0, loading }
}
